var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2371_1044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13437 0 0 3.13437 0 7C0 10.8656 3.13437 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13437 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z",
    fill: "#D58000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62476 8H7.37476C7.44351 8 7.49976 7.94375 7.49976 7.875V3.625C7.49976 3.55625 7.44351 3.5 7.37476 3.5H6.62476C6.55601 3.5 6.49976 3.55625 6.49976 3.625V7.875C6.49976 7.94375 6.55601 8 6.62476 8Z",
    fill: "#D58000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24976 9.75C6.24976 9.94891 6.32877 10.1397 6.46943 10.2803C6.61008 10.421 6.80084 10.5 6.99976 10.5C7.19867 10.5 7.38943 10.421 7.53009 10.2803C7.67074 10.1397 7.74976 9.94891 7.74976 9.75C7.74976 9.55109 7.67074 9.36032 7.53009 9.21967C7.38943 9.07902 7.19867 9 6.99976 9C6.80084 9 6.61008 9.07902 6.46943 9.21967C6.32877 9.36032 6.24976 9.55109 6.24976 9.75Z",
    fill: "#D58000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2371_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationOrange);
export default __webpack_public_path__ + "static/media/exclamation-orange.e925cb751293095462b8e7c6717a2c39.svg";
export { ForwardRef as ReactComponent };